export default function WarehouseSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="space-y-4">
        {/* Warehouse Info Skeleton */}
        <div className="border rounded-lg p-4 space-y-4 bg-white shadow">
          <div className="flex justify-between items-center pb-2">
            <div className="h-6 w-40 bg-gray-300 rounded"></div>
            <div className="h-8 w-24 bg-gray-300 rounded-full"></div>
          </div>

          {[...Array(2)].map((_, i) => (
            <div key={i} className="grid grid-cols-4 gap-4">
              <div className="h-5 w-24 bg-gray-300 rounded"></div>
              <div className="h-5 w-40 bg-gray-300 rounded"></div>
              <div className="h-5 w-40 bg-gray-300 rounded"></div>
              <div className="h-5 w-40 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>

        {/* Coverage Info Skeleton */}
        <div className="border rounded-lg p-4 bg-white shadow space-y-4">
          <div className="h-6 w-40 bg-gray-300 rounded"></div>
          <div className="space-y-2">
            {[...Array(5)].map((_, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-8 gap-4">
                {[...Array(8)].map((_, colIndex) => (
                  <div
                    key={colIndex}
                    className="h-4 bg-gray-300 rounded col-span-1"
                  ></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
